<template>
  <v-overlay>
    <v-progress-circular
      :size="90"
      :width="15"
      color="purple"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "Vue_Loading",
};
</script>

<style scoped></style>
